import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-6 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2 font-heading text-xl text-primary-600">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-sm"></i>
            </span>
            <span>天天漫画网</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            每日更新热门连载漫画，追更漫画不迷路。今日更新最新话同步上线，连载漫画随时点开随时看。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-bold text-foreground-900">快速导航</h4>
          <ul className="space-y-3 text-sm text-foreground-600">
            <li><Link className="hover:text-primary-600" to="/">首页</Link></li>
            <li><Link className="hover:text-primary-600" to="/list">漫库列表</Link></li>
            <li><Link className="hover:text-primary-600" to="/about">关于我们</Link></li>
            <li><Link className="hover:text-primary-600" to="/faq">常见问题</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-bold text-foreground-900">漫画分类</h4>
          <ul className="grid grid-cols-2 gap-3 text-sm text-foreground-600">
            {categories.map((c) => (
              <li key={c.id}>
                <Link className="hover:text-primary-600" to={`/list?category=${c.id}`}>{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-bold text-foreground-900">联系我们</h4>
          <ul className="space-y-3 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              <span>service@tiantian-mh.example.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500"></i>
              <span>每日 08:00 起持续更新</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-user-heart-line text-primary-500"></i>
              <span>千万追更党一起看</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 天天漫画网 版权所有，仅供内容展示与交流。</p>
          <p className="flex items-center gap-2">
            <i className="ri-heart-fill text-accent-500"></i>
            每日更新 · 追更不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}